const faqItems = [
  {
    q: '飞飞漫画网上的漫画真的全部免费吗？',
    a: '是的！飞飞漫画网所有漫画资源均为免费在线阅读，不设付费墙。涵盖国漫、日漫、韩漫等分类，无需注册即可畅读全站，下拉式阅读让你随心翻阅。',
  },
  {
    q: '什么是下拉式阅读？相比翻页有哪些优势？',
    a: '下拉式阅读是一种连续滚动浏览模式，所有漫画内容在一页内无缝衔接。相比传统翻页模式，下拉式更流畅自然，无需等待页面加载，尤其适合移动端快速追更。',
  },
  {
    q: '漫画更新频率如何？多久更新一次？',
    a: '飞飞漫画网每日同步各大平台最新更新，热门连载平均每天新增 300+ 话。我们会第一时间抓取并发布，确保你追更不落进度，热门作品更新后 1 小时内即可阅读。',
  },
  {
    q: '支持哪些设备阅读？有APP吗？',
    a: '飞飞漫画网全面支持 PC 网页、手机浏览器和专属 APP。iOS 和 Android 客户端均已在各大应用商店上架，支持离线缓存、智能书签、夜间模式等功能。',
  },
  {
    q: '如何找到我想看的漫画？有搜索和分类吗？',
    a: '首页提供热门推荐、排行榜和分类导航，你可以按国漫、日漫、韩漫、完结等标签快速筛选。热门话题区也聚集了当前最火的讨论和推荐，帮你发现好作品。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            关于飞飞漫画网的免费阅读、使用方式和更新机制，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-colors"
            >
              <h3 className="font-heading text-base text-foreground-950 mb-2">
                <span className="text-primary-500 mr-2 font-bold">Q{i + 1}.</span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}